
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aC5ZO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bcDqz = parcelRequire("bcDqz");


var $3izAL = parcelRequire("3izAL");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $lpNn5 = parcelRequire("lpNn5");


var $ep3mz = parcelRequire("ep3mz");


var $ePExc = parcelRequire("ePExc");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $jjv3l = parcelRequire("jjv3l");


var $jmjWc = parcelRequire("jmjWc");


var $hlpSM = parcelRequire("hlpSM");


var $iwQHw = parcelRequire("iwQHw");


var $c6zRP = parcelRequire("c6zRP");


var $9VtwR = parcelRequire("9VtwR");


var $azPio = parcelRequire("azPio");








var $iMnC5 = parcelRequire("iMnC5");








var $dv6q2 = parcelRequire("dv6q2");


var $uBose = parcelRequire("uBose");

const $f0ec2e1e638ea1ae$export$5baa88db8a182af5 = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { index: index, participant: participant, contentMode: contentMode, contentType: contentType, contentId: contentId, isSingleParticipant: isSingleParticipant, isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, avatarProps: avatarProps, analyticSource: analyticSource } = t0;
    const { id: id } = participant;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const t1 = participant;
    let t2;
    if ($[0] !== contentMode || $[1] !== contentType || $[2] !== t1) {
        t2 = {
            contentType: contentType,
            contentMode: contentMode,
            participant: t1
        };
        $[0] = contentMode;
        $[1] = contentType;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $dv6q2.useScrollToTelepointer)(t2);
    let t3;
    if ($[4] !== analyticSource || $[5] !== contentId || $[6] !== contentMode || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== isEligibleForEmptyPresenceDialog || $[10] !== isEligibleToScroll || $[11] !== isScrollToFeatureEnabled || $[12] !== isSingleParticipant || $[13] !== participant.onClick || $[14] !== scrollToTelepointer || $[15] !== toggleEmptyPresenceDialog) {
        t3 = ()=>{
            if (isSingleParticipant) return isEligibleForEmptyPresenceDialog ? toggleEmptyPresenceDialog : undefined;
            if (isEligibleToScroll) return ()=>{
                const isScrollSuccessful = scrollToTelepointer();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: analyticSource,
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "presenceAvatarButton",
                        product: "confluence",
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            contentMode: contentMode,
                            isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                            isEligibleToScroll: isEligibleToScroll,
                            isScrollSuccessful: isScrollSuccessful
                        }
                    }
                }).fire();
            };
            return participant?.onClick;
        };
        $[4] = analyticSource;
        $[5] = contentId;
        $[6] = contentMode;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = isEligibleForEmptyPresenceDialog;
        $[10] = isEligibleToScroll;
        $[11] = isScrollToFeatureEnabled;
        $[12] = isSingleParticipant;
        $[13] = participant.onClick;
        $[14] = scrollToTelepointer;
        $[15] = toggleEmptyPresenceDialog;
        $[16] = t3;
    } else t3 = $[16];
    const getAvatarButtonOnClickHandler = t3;
    const t4 = `box-${id}`;
    const t5 = `avatar-${id}`;
    const t6 = (0, $9VtwR.MAX_GROUP_SIZE) - index;
    const t7 = `team-presence-avatar-${index}`;
    let t8;
    if ($[17] !== getAvatarButtonOnClickHandler) {
        t8 = getAvatarButtonOnClickHandler();
        $[17] = getAvatarButtonOnClickHandler;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== avatarProps || $[20] !== contentId || $[21] !== contentMode || $[22] !== contentType || $[23] !== isEligibleToScroll || $[24] !== isScrollToFeatureEnabled || $[25] !== participant || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uBose.PresenceAvatar), {
            ...avatarProps,
            participant: participant,
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            key: t5,
            stackIndex: t6,
            testId: t7,
            onClick: t8,
            isEligibleToScroll: isEligibleToScroll,
            isScrollToFeatureEnabled: isScrollToFeatureEnabled
        });
        $[19] = avatarProps;
        $[20] = contentId;
        $[21] = contentMode;
        $[22] = contentType;
        $[23] = isEligibleToScroll;
        $[24] = isScrollToFeatureEnabled;
        $[25] = participant;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== t4 || $[32] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            padding: "space.0",
            key: t4,
            "data-vc": "presence-avatar"
        }, t9);
        $[31] = t4;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};



const $012cae68941ce2ca$var$NoCollaboratorsDialog = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xe4Dq",
    name: "NoCollaboratorsDialog",
    loader: async ()=>(await (parcelRequire("8ISxc"))).NoCollaboratorsDialog
});

const $012cae68941ce2ca$var$PresenceMenuWithGuest = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8nVZu",
    name: "PresenceMenuWithGuest",
    loader: async ()=>(await (parcelRequire("3uWTb"))).PresenceMenuWithGuest
});
const $012cae68941ce2ca$var$i18n = (0, $kSwu1.defineMessages)({
    overflowLabel: {
        id: "team-presence.avatar-group.overflow-label",
        defaultMessage: "Overflow menu"
    },
    blogpostLandmark: {
        id: "team-presence.avatar-group.blogpost-landmark",
        defaultMessage: "Active people on blog post"
    },
    pageLandmark: {
        id: "team-presence.avatar-group.page-landmark",
        defaultMessage: "Active people on page"
    },
    agentEditingTooltip: {
        id: "team-presence.avatar-group.agent-editing-tooltip",
        defaultMessage: "{name} (Editing)"
    },
    agentEditingWithActorTooltip: {
        id: "team-presence.avatar-group.agent-editing-with-actor-tooltip",
        defaultMessage: "{name} with {actorName} (Editing)"
    },
    agentEditingInactiveTooltip: {
        id: "team-presence.avatar-group.agent-editing-inactive-tooltip",
        defaultMessage: "{name} (Editing) Inactive"
    },
    agentEditingWithActorInactiveTooltip: {
        id: "team-presence.avatar-group.agent-editing-with-actor-inactive-tooltip",
        defaultMessage: "{name} with {actorName} (Editing) Inactive"
    },
    agentViewingTooltip: {
        id: "team-presence.avatar-group.agent-viewing-tooltip",
        defaultMessage: "{name} (Viewing)"
    },
    agentViewingWithActorTooltip: {
        id: "team-presence.avatar-group.agent-viewing-with-actor-tooltip",
        defaultMessage: "{name} with {actorName} (Viewing)"
    },
    agentViewingInactiveTooltip: {
        id: "team-presence.avatar-group.agent-viewing-inactive-tooltip",
        defaultMessage: "{name} (Viewing) Inactive"
    },
    agentViewingWithActorInactiveTooltip: {
        id: "team-presence.avatar-group.agent-viewing-with-actor-inactive-tooltip",
        defaultMessage: "{name} with {actorName} (Viewing) Inactive"
    }
});
const $012cae68941ce2ca$export$7ca709480849ec24 = (item)=>item.itemType === 'agent';
const $012cae68941ce2ca$export$151d4e976be28b6c = (participant)=>(0, $azPio.getAgentPresenceKind)({
        kind: participant.avatarKind
    }) === 'external-agent';
const $012cae68941ce2ca$export$54aeb6445ae7b112 = (participant)=>(0, $azPio.hasAgentPresenceMetadata)({
        agentId: participant.agentId,
        agentType: participant.agentType,
        kind: participant.avatarKind
    });
const $012cae68941ce2ca$export$1632fc3ec158d8d3 = (participants, agents)=>[
        ...participants.map((participant)=>({
                ...participant,
                itemType: 'participant',
                participant: participant
            })),
        ...agents.map((agent)=>({
                itemType: 'agent',
                agent: agent,
                name: agent.name
            }))
    ];
const $012cae68941ce2ca$export$e20f74189dc27c74 = (avatarItems, index)=>avatarItems[index];
const $012cae68941ce2ca$export$8bf0497aa5a807f4 = ({ totalPresenceItems: totalPresenceItems, participantCount: participantCount, isLoggedIn: isLoggedIn, isGuest: isGuest, isExternal: isExternal })=>{
    return totalPresenceItems === 1 && participantCount === 1 && isLoggedIn && !isGuest && !isExternal;
};
const $012cae68941ce2ca$export$6eff163b6a2b77e6 = ({ isAgentPresenceMoveEnabled: isAgentPresenceMoveEnabled, children: children, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider })=>{
    if (!isAgentPresenceMoveEnabled || !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(children)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        isNestedInPresenceAvatarGroup: true,
        onActiveAgentsChange: onActiveAgentsChange,
        presenceProvider: presenceProvider
    });
};
const $012cae68941ce2ca$var$EMPTY_AGENTS = [];
const $012cae68941ce2ca$var$popupContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    position: 'relative',
    width: '360px'
});
const $012cae68941ce2ca$var$editObjectHeaderStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0'
});
const $012cae68941ce2ca$var$activePeopleRegionStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $012cae68941ce2ca$var$overflowMoreStyles = (0, $buxP3.xcss)({
    padding: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'radius.full',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    font: 'font.heading.xxsmall',
    ':hover': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $012cae68941ce2ca$var$moreActiveStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $012cae68941ce2ca$export$f346a77ef828fbad = (agent, actingUserName)=>{
    const isInactive = (0, $c6zRP.isAgentPresenceInactive)(agent);
    if (agent.presenceActivity === 'editor') {
        if (actingUserName) return isInactive ? $012cae68941ce2ca$var$i18n.agentEditingWithActorInactiveTooltip : $012cae68941ce2ca$var$i18n.agentEditingWithActorTooltip;
        return isInactive ? $012cae68941ce2ca$var$i18n.agentEditingInactiveTooltip : $012cae68941ce2ca$var$i18n.agentEditingTooltip;
    }
    if (actingUserName) return isInactive ? $012cae68941ce2ca$var$i18n.agentViewingWithActorInactiveTooltip : $012cae68941ce2ca$var$i18n.agentViewingWithActorTooltip;
    return isInactive ? $012cae68941ce2ca$var$i18n.agentViewingInactiveTooltip : $012cae68941ce2ca$var$i18n.agentViewingTooltip;
};
const $012cae68941ce2ca$var$indicatorBaseStyles = (0, $buxP3.xcss)({
    minWidth: '28px',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    borderRadius: 'radius.small',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineOffset: 'space.050'
    }
});
const $012cae68941ce2ca$var$indicatorOverflowStyles = (0, $buxP3.xcss)({
    minWidth: '35px',
    maxWidth: '35px'
});
const $012cae68941ce2ca$export$fc163eae181faed4 = (t0)=>{
    const $ = (0, $bDgLe.c)(115);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, analyticSource: analyticSource, popupOpen: popupOpen, participants: participants, totalParticipants: totalParticipants, children: children, presenceProvider: presenceProvider, externalAgentAvatarComponent: ExternalAgentAvatarComponent } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { displayName: displayName, isLoggedIn: isLoggedIn, userId: userId } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isExternal = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(popupOpen || false);
    const [isShareDialogOpen, setIsShareDialogOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [activeAgents, setActiveAgents] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] !== activeAgents) {
        t2 = (0, $9wGTI.fg)("platform_move_presence_agents") ? activeAgents : $012cae68941ce2ca$var$EMPTY_AGENTS;
        $[1] = activeAgents;
        $[2] = t2;
    } else t2 = $[2];
    const combinedPresenceAgents = t2;
    let t3;
    if ($[3] !== combinedPresenceAgents || $[4] !== participants) {
        t3 = $012cae68941ce2ca$export$1632fc3ec158d8d3(participants, combinedPresenceAgents);
        $[3] = combinedPresenceAgents;
        $[4] = participants;
        $[5] = t3;
    } else t3 = $[5];
    const avatarItems = t3;
    let t4;
    if ($[6] !== participants) {
        t4 = participants.some($012cae68941ce2ca$export$54aeb6445ae7b112);
        $[6] = participants;
        $[7] = t4;
    } else t4 = $[7];
    const hasCanvasAgentParticipant = t4;
    let userNamesById;
    if ($[8] !== displayName || $[9] !== participants || $[10] !== userId) {
        userNamesById = new Map(participants.map($012cae68941ce2ca$var$_temp));
        if (userId && displayName) userNamesById.set(userId, displayName);
        $[8] = displayName;
        $[9] = participants;
        $[10] = userId;
        $[11] = userNamesById;
    } else userNamesById = $[11];
    const participantsByUserId = userNamesById;
    const totalPresenceItems = totalParticipants + combinedPresenceAgents.length;
    let t5;
    if ($[12] !== isExternal || $[13] !== isGuest || $[14] !== isLoggedIn || $[15] !== participants.length || $[16] !== totalPresenceItems) {
        t5 = ()=>$012cae68941ce2ca$export$8bf0497aa5a807f4({
                totalPresenceItems: totalPresenceItems,
                participantCount: participants.length,
                isLoggedIn: isLoggedIn,
                isGuest: isGuest,
                isExternal: isExternal
            });
        $[12] = isExternal;
        $[13] = isGuest;
        $[14] = isLoggedIn;
        $[15] = participants.length;
        $[16] = totalPresenceItems;
        $[17] = t5;
    } else t5 = $[17];
    const isEligibleForEmptyPresenceDialog = t5;
    let t6;
    let t7;
    if ($[18] !== isPopupOpen || $[19] !== totalPresenceItems) {
        t6 = ()=>{
            if (isPopupOpen && totalPresenceItems > 1 && totalPresenceItems <= (0, $9VtwR.MAX_GROUP_SIZE)) setIsPopupOpen(false);
        };
        t7 = [
            isPopupOpen,
            totalPresenceItems
        ];
        $[18] = isPopupOpen;
        $[19] = totalPresenceItems;
        $[20] = t6;
        $[21] = t7;
    } else {
        t6 = $[20];
        t7 = $[21];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[22] !== contentId || $[23] !== contentMode || $[24] !== contentType || $[25] !== createAnalyticsEvent) {
        t8 = (analyticsTriggerSource)=>{
            setIsPopupOpen(false);
            setIsShareDialogOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticsTriggerSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceShare",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        shareDialog: "v2"
                    }
                }
            }).fire();
        };
        $[22] = contentId;
        $[23] = contentMode;
        $[24] = contentType;
        $[25] = createAnalyticsEvent;
        $[26] = t8;
    } else t8 = $[26];
    const handleShareClick = t8;
    let t9;
    if ($[27] !== analyticSource || $[28] !== contentId || $[29] !== contentMode || $[30] !== contentType || $[31] !== createAnalyticsEvent || $[32] !== isPopupOpen) {
        t9 = ()=>{
            setIsPopupOpen($012cae68941ce2ca$var$_temp2);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "singlePresenceAvatarGroup",
                    product: "confluence",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        toggle: isPopupOpen ? "close" : "open"
                    }
                }
            }).fire();
        };
        $[27] = analyticSource;
        $[28] = contentId;
        $[29] = contentMode;
        $[30] = contentType;
        $[31] = createAnalyticsEvent;
        $[32] = isPopupOpen;
        $[33] = t9;
    } else t9 = $[33];
    const toggleEmptyPresenceDialog = t9;
    const isSingleParticipant = totalPresenceItems === 1;
    let t10;
    if ($[34] !== analyticSource || $[35] !== contentId || $[36] !== contentMode || $[37] !== contentType || $[38] !== createAnalyticsEvent) {
        t10 = (e, number)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceAvatarGroupMoreButton",
                    product: "confluence",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        number: number
                    }
                }
            }).fire();
            setIsPopupOpen($012cae68941ce2ca$var$_temp3);
            e.stopPropagation();
        };
        $[34] = analyticSource;
        $[35] = contentId;
        $[36] = contentMode;
        $[37] = contentType;
        $[38] = createAnalyticsEvent;
        $[39] = t10;
    } else t10 = $[39];
    const onMoreClick = t10;
    let t11;
    if ($[40] !== isSingleParticipant) {
        t11 = ()=>isSingleParticipant ? "no-collaborators-dialog" : "presence-menu";
        $[40] = isSingleParticipant;
        $[41] = t11;
    } else t11 = $[41];
    const getTriggerId = t11;
    const triggerId = getTriggerId();
    let t12;
    if ($[42] !== contentId || $[43] !== contentMode || $[44] !== contentType || $[45] !== handleShareClick || $[46] !== spaceKey || $[47] !== triggerId) {
        t12 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($012cae68941ce2ca$var$NoCollaboratorsDialog, {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                spaceKey: spaceKey || "",
                onShareClick: handleShareClick,
                testId: triggerId
            });
        $[42] = contentId;
        $[43] = contentMode;
        $[44] = contentType;
        $[45] = handleShareClick;
        $[46] = spaceKey;
        $[47] = triggerId;
        $[48] = t12;
    } else t12 = $[48];
    const renderNoCollaboratorsDialog = t12;
    let t13;
    if ($[49] !== ExternalAgentAvatarComponent || $[50] !== combinedPresenceAgents || $[51] !== contentId || $[52] !== contentMode || $[53] !== contentType || $[54] !== hasCanvasAgentParticipant || $[55] !== participants || $[56] !== totalPresenceItems) {
        t13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($012cae68941ce2ca$var$PresenceMenuWithGuest, {
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                participants: participants,
                agents: combinedPresenceAgents,
                totalParticipants: totalPresenceItems,
                externalAgentAvatarComponent: ExternalAgentAvatarComponent && hasCanvasAgentParticipant && (0, $9wGTI.fg)("canvas_agent_presence_facepile_frontend") ? ExternalAgentAvatarComponent : undefined
            });
        $[49] = ExternalAgentAvatarComponent;
        $[50] = combinedPresenceAgents;
        $[51] = contentId;
        $[52] = contentMode;
        $[53] = contentType;
        $[54] = hasCanvasAgentParticipant;
        $[55] = participants;
        $[56] = totalPresenceItems;
        $[57] = t13;
    } else t13 = $[57];
    const renderPresenceMenu = t13;
    let t14;
    if ($[58] !== isSingleParticipant || $[59] !== renderNoCollaboratorsDialog || $[60] !== renderPresenceMenu) {
        const getPopUpContent = ()=>isSingleParticipant ? renderNoCollaboratorsDialog() : renderPresenceMenu();
        t14 = getPopUpContent();
        $[58] = isSingleParticipant;
        $[59] = renderNoCollaboratorsDialog;
        $[60] = renderPresenceMenu;
        $[61] = t14;
    } else t14 = $[61];
    const PopupContent = t14;
    const overflowParticipantCount = totalPresenceItems - (0, $9VtwR.MAX_GROUP_SIZE) + 1;
    let t15;
    if ($[62] !== contentType || $[63] !== formatMessage) {
        t15 = contentType === "blogpost" ? formatMessage($012cae68941ce2ca$var$i18n.blogpostLandmark) : formatMessage($012cae68941ce2ca$var$i18n.pageLandmark);
        $[62] = contentType;
        $[63] = formatMessage;
        $[64] = t15;
    } else t15 = $[64];
    const landmarkRegionLabel = t15;
    const isEditObjectHeader = contentMode === "edit" || contentMode === "live";
    let t16;
    if ($[65] !== children || $[66] !== presenceProvider) {
        t16 = $012cae68941ce2ca$export$6eff163b6a2b77e6({
            isAgentPresenceMoveEnabled: (0, $9wGTI.fg)("platform_move_presence_agents"),
            children: children,
            onActiveAgentsChange: setActiveAgents,
            presenceProvider: presenceProvider
        });
        $[65] = children;
        $[66] = presenceProvider;
        $[67] = t16;
    } else t16 = $[67];
    const nestedPresenceContent = t16;
    let t17;
    if ($[68] !== analyticSource || $[69] !== avatarItems || $[70] !== contentId || $[71] !== contentMode || $[72] !== contentType || $[73] !== formatMessage || $[74] !== isEligibleForEmptyPresenceDialog || $[75] !== isSingleParticipant || $[76] !== participantsByUserId || $[77] !== toggleEmptyPresenceDialog) {
        t17 = (_, props, index)=>{
            const avatarItem = $012cae68941ce2ca$export$e20f74189dc27c74(avatarItems, index);
            if (!avatarItem) return null;
            if ($012cae68941ce2ca$export$7ca709480849ec24(avatarItem)) {
                const actingUserName = avatarItem.agent.actingUserId ? participantsByUserId.get(avatarItem.agent.actingUserId) : undefined;
                const agentTooltipMessage = $012cae68941ce2ca$export$f346a77ef828fbad(avatarItem.agent, actingUserName);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: `AgentPresenceAvatar-${(0, $hlpSM.getAgentPresenceKey)({
                        ...avatarItem.agent,
                        includeActingUser: (0, $9wGTI.fg)("platform_move_presence_agents")
                    })}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: formatMessage(agentTooltipMessage, {
                        actorName: actingUserName,
                        name: avatarItem.agent.name
                    }),
                    position: "bottom"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
                    agent: avatarItem.agent,
                    size: "small",
                    stackIndex: (0, $9VtwR.MAX_GROUP_SIZE) - index,
                    showBorder: true
                })));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                key: `PresenceAvatarButton-${avatarItem.participant.id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0ec2e1e638ea1ae$export$5baa88db8a182af5), {
                index: index,
                participant: avatarItem.participant,
                contentMode: contentMode,
                contentType: contentType,
                contentId: contentId,
                isSingleParticipant: isSingleParticipant,
                isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog(),
                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                avatarProps: props,
                analyticSource: analyticSource
            }));
        };
        $[68] = analyticSource;
        $[69] = avatarItems;
        $[70] = contentId;
        $[71] = contentMode;
        $[72] = contentType;
        $[73] = formatMessage;
        $[74] = isEligibleForEmptyPresenceDialog;
        $[75] = isSingleParticipant;
        $[76] = participantsByUserId;
        $[77] = toggleEmptyPresenceDialog;
        $[78] = t17;
    } else t17 = $[78];
    const renderAvatar = t17;
    let t18;
    if ($[79] !== ExternalAgentAvatarComponent || $[80] !== avatarItems || $[81] !== contentId || $[82] !== contentMode || $[83] !== contentType || $[84] !== renderAvatar) {
        t18 = (data, props_0, index_0)=>{
            const avatarItem_0 = $012cae68941ce2ca$export$e20f74189dc27c74(avatarItems, index_0);
            if (!avatarItem_0 || $012cae68941ce2ca$export$7ca709480849ec24(avatarItem_0) || !ExternalAgentAvatarComponent || !$012cae68941ce2ca$export$54aeb6445ae7b112(avatarItem_0.participant)) return renderAvatar(data, props_0, index_0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                key: `PresenceAvatarButton-${avatarItem_0.participant.id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                padding: "space.0",
                "data-vc": "presence-avatar"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExternalAgentAvatarComponent, {
                ...props_0,
                participant: avatarItem_0.participant,
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                stackIndex: (0, $9VtwR.MAX_GROUP_SIZE) - index_0,
                testId: `team-presence-avatar-${index_0}`,
                onClick: undefined,
                isEligibleToScroll: false,
                isScrollToFeatureEnabled: false
            })));
        };
        $[79] = ExternalAgentAvatarComponent;
        $[80] = avatarItems;
        $[81] = contentId;
        $[82] = contentMode;
        $[83] = contentType;
        $[84] = renderAvatar;
        $[85] = t18;
    } else t18 = $[85];
    const renderExternalAgentAwareAvatar = t18;
    let t19;
    if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
        });
        $[86] = t19;
    } else t19 = $[86];
    let t20;
    if ($[87] !== contentId || $[88] !== contentType || $[89] !== isShareDialogOpen || $[90] !== participants.length) {
        t20 = participants.length === 1 && isShareDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ePExc.ShareAndRestrictDialogController), {
            contentId: contentId,
            contentType: contentType,
            allowRestrictions: true,
            pageModes: "view",
            refetchButtonData: $012cae68941ce2ca$var$_temp4,
            onClose: ()=>{
                setIsShareDialogOpen(false);
            },
            isUnpublishedDraft: false
        });
        $[87] = contentId;
        $[88] = contentType;
        $[89] = isShareDialogOpen;
        $[90] = participants.length;
        $[91] = t20;
    } else t20 = $[91];
    let t21;
    if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = ()=>setIsPopupOpen(false);
        $[92] = t21;
    } else t21 = $[92];
    let t22;
    if ($[93] !== PopupContent) {
        t22 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $012cae68941ce2ca$var$popupContainerStyles
            }, PopupContent);
        $[93] = PopupContent;
        $[94] = t22;
    } else t22 = $[94];
    let t23;
    if ($[95] !== ExternalAgentAvatarComponent || $[96] !== avatarItems || $[97] !== formatMessage || $[98] !== hasCanvasAgentParticipant || $[99] !== isEditObjectHeader || $[100] !== isPopupOpen || $[101] !== landmarkRegionLabel || $[102] !== nestedPresenceContent || $[103] !== onMoreClick || $[104] !== overflowParticipantCount || $[105] !== renderAvatar || $[106] !== renderExternalAgentAwareAvatar) {
        t23 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                ...triggerProps,
                paddingInline: "space.050",
                "aria-label": landmarkRegionLabel,
                role: "region",
                xcss: [
                    (0, $9wGTI.fg)("platform_move_presence_agents") && $012cae68941ce2ca$var$activePeopleRegionStyles,
                    isEditObjectHeader && $012cae68941ce2ca$var$editObjectHeaderStyles
                ],
                "data-vc": "presence-avatar-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $9VtwR.MAX_GROUP_SIZE),
                data: avatarItems,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #0515240F)",
                onMoreClick: (e_0)=>onMoreClick(e_0, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: ExternalAgentAvatarComponent && hasCanvasAgentParticipant && (0, $9wGTI.fg)("canvas_agent_presence_facepile_frontend") ? renderExternalAgentAwareAvatar : renderAvatar
                    },
                    MoreIndicator: {
                        render: (__0, t24)=>{
                            const { buttonProps: buttonProps, isActive: __, borderColor: ___, ...rest } = t24;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                                type: "submit",
                                ...buttonProps,
                                ...rest,
                                padding: "space.0",
                                onClick: rest.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorBaseStyles,
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount));
                        }
                    }
                }
            }), nestedPresenceContent);
        $[95] = ExternalAgentAvatarComponent;
        $[96] = avatarItems;
        $[97] = formatMessage;
        $[98] = hasCanvasAgentParticipant;
        $[99] = isEditObjectHeader;
        $[100] = isPopupOpen;
        $[101] = landmarkRegionLabel;
        $[102] = nestedPresenceContent;
        $[103] = onMoreClick;
        $[104] = overflowParticipantCount;
        $[105] = renderAvatar;
        $[106] = renderExternalAgentAwareAvatar;
        $[107] = t23;
    } else t23 = $[107];
    let t24;
    if ($[108] !== isPopupOpen || $[109] !== t22 || $[110] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isPopupOpen,
            onClose: t21,
            placement: "bottom-end",
            content: t22,
            trigger: t23
        });
        $[108] = isPopupOpen;
        $[109] = t22;
        $[110] = t23;
        $[111] = t24;
    } else t24 = $[111];
    let t25;
    if ($[112] !== t20 || $[113] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t19, t20, t24);
        $[112] = t20;
        $[113] = t24;
        $[114] = t25;
    } else t25 = $[114];
    return t25;
};
function $012cae68941ce2ca$var$_temp(participant) {
    return [
        participant.userId,
        participant.name
    ];
}
function $012cae68941ce2ca$var$_temp2(isPopupOpenState) {
    return !isPopupOpenState;
}
function $012cae68941ce2ca$var$_temp3(isPopupOpenState_0) {
    return !isPopupOpenState_0;
}
function $012cae68941ce2ca$var$_temp4() {}
module.exports["PresenceAvatarGroup"] = $012cae68941ce2ca$export$fc163eae181faed4;

});

parcelRegister("azPio", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c25227de93a964b9$var$i18n = (0, $kSwu1.defineMessages)({
    rovo: {
        id: "team-presence.rovo-agent.name",
        defaultMessage: "Rovo"
    },
    externalAgent: {
        id: "team-presence.external-agent.name",
        defaultMessage: "External agent"
    },
    nameWithActor: {
        id: "team-presence.avatar-group.agent-with-actor-tooltip",
        defaultMessage: "{name} with {actorName}"
    }
});
const $c25227de93a964b9$var$getFallbackLabelMessage = (kind)=>{
    if (kind === 'rovo-agent') return $c25227de93a964b9$var$i18n.rovo;
    if (kind === 'external-agent') return $c25227de93a964b9$var$i18n.externalAgent;
    return undefined;
};
const $c25227de93a964b9$export$f035b8df45535a49 = (kind)=>{
    if (kind === 'rovo-agent' || kind === 'external-agent') return kind;
    return undefined;
};
const $c25227de93a964b9$var$toAgentLabelKindFromAgentType = (agentType)=>{
    if (!agentType || agentType === 'unknown') return undefined;
    if (agentType === 'rovo_chat' || agentType === 'convo-ai' || agentType === 'convo_ai') return 'rovo-agent';
    return 'external-agent';
};
const $c25227de93a964b9$export$ccde08b8c5a627a7 = ({ agentType: agentType, isExternalAgentFallback: isExternalAgentFallback, isRovoAgentFallback: isRovoAgentFallback, kind: kind })=>{
    const collaboratorKind = $c25227de93a964b9$export$f035b8df45535a49(kind);
    if (collaboratorKind) return collaboratorKind;
    if (isRovoAgentFallback) return 'rovo-agent';
    const agentTypeKind = $c25227de93a964b9$var$toAgentLabelKindFromAgentType(agentType);
    if (agentTypeKind) return agentTypeKind;
    if (isExternalAgentFallback) return 'external-agent';
    return undefined;
};
const $c25227de93a964b9$export$d5dcd46e9638ed93 = ({ agentId: agentId, agentType: agentType, kind: kind })=>Boolean(agentId) || $c25227de93a964b9$export$ccde08b8c5a627a7({
        agentType: agentType,
        kind: kind
    }) !== undefined;
const $c25227de93a964b9$export$5150708bc8b986ea = ({ kind: kind, name: name }, formatMessage)=>{
    if (name) return name;
    const fallbackLabel = $c25227de93a964b9$var$getFallbackLabelMessage($c25227de93a964b9$export$ccde08b8c5a627a7({
        kind: kind
    }));
    return fallbackLabel ? formatMessage(fallbackLabel) : '';
};
const $c25227de93a964b9$export$96ffbafa28a020f9 = (options, formatMessage)=>{
    const kind = $c25227de93a964b9$export$ccde08b8c5a627a7(options);
    const name = $c25227de93a964b9$export$5150708bc8b986ea({
        kind: kind,
        name: options.name
    }, formatMessage);
    if (!options.actorName) return name;
    return formatMessage($c25227de93a964b9$var$i18n.nameWithActor, {
        actorName: options.actorName,
        name: name
    });
};
module.exports["toAgentLabelKind"] = $c25227de93a964b9$export$f035b8df45535a49;
module.exports["getAgentPresenceKind"] = $c25227de93a964b9$export$ccde08b8c5a627a7;
module.exports["hasAgentPresenceMetadata"] = $c25227de93a964b9$export$d5dcd46e9638ed93;
module.exports["getAgentPresenceDisplayName"] = $c25227de93a964b9$export$5150708bc8b986ea;
module.exports["formatAgentPresenceLabel"] = $c25227de93a964b9$export$96ffbafa28a020f9;

});

parcelRegister("dv6q2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jbOus = parcelRequire("jbOus");


var $kDhla = parcelRequire("kDhla");


var $e4o8D = parcelRequire("e4o8D");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $lkApp = parcelRequire("lkApp");

const $99b335d011a83318$export$d32c4eeaa4d40cd3 = (sessionId)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`[${(0, $jbOus.TELEPOINTER_DATA_SESSION_ID_ATTR)}="${sessionId}"]`);
};
const $99b335d011a83318$export$3e8e4ca69eec4635 = ({ contentType: contentType, contentMode: contentMode, participant: participant })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
    const participantSessions = participant?.sessions ?? {};
    const [activeTelepointer] = (0, $lkApp.useActiveTelepointerBySessions)(participantSessions);
    const activeTelepointerPos = activeTelepointer?.selection.head;
    const activeSessionId = activeTelepointer?.sessionId;
    const sessionData = participantSessions[activeSessionId];
    const telepointerEl = isServerPlaceholder ? null : $99b335d011a83318$export$d32c4eeaa4d40cd3(activeSessionId);
    // Keep the optional chaning until we have a stricter "PresenceSessionData"
    const activity = sessionData?.activity;
    const isScrollToFeatureEnabled = // This feature is only available for live docs (for "editing" users), and pages and blogposts in edit mode
    ((contentType === 'page' || contentType === 'blogpost') && contentMode === 'edit' || contentMode === 'live' && activity !== 'viewer') && // Current user won't have the onClick handler for scroll
    !participant?.isCurrentUser;
    const isEligibleToScroll = isScrollToFeatureEnabled && // This is to filter out cases like where we have a user but no telepointer data; e.g. no focus on the doc
    activeTelepointerPos !== undefined && activeSessionId !== undefined && // Even if we have telepointer data, that doesn't guarantee the telepointer will be in the DOM.
    // e.g. platform_editor_no_telecursor_on_live_doc_init,
    telepointerEl !== null;
    const observerRef = (0, $cozmU.useRef)(null);
    const timeoutRef = (0, $cozmU.useRef)(null);
    const killObserver = ()=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Abort ongoing experience in case it's stuck in an unexpected state
            const expState = experienceTracker.getExperienceState((0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE));
            if (expState?.attributes?.sessionId === activeSessionId && !expState?.hasStopped) experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                reason: 'useScrollToTelepointer unmounted'
            });
        };
    }, [
        activeSessionId,
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            killObserver();
        };
    }, []);
    const scrollToTelepointer = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                sessionId: activeSessionId,
                activity: activity
            }
        });
        try {
            killObserver();
            const scrollToPos = fullPageEditorPresetAPI?.core.actions.scrollToPos;
            const nudgeTelepointer = fullPageEditorPresetAPI?.collabEdit?.commands.nudgeTelepointer;
            if (!isEligibleToScroll || !scrollToPos) {
                experienceTracker.fail({
                    name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                    error: new Error('Eligibility checks failed'),
                    attributes: {
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollToPosDefined: scrollToPos !== undefined
                    }
                });
                return false;
            }
            const isScrollSuccessful = scrollToPos(Number(activeTelepointerPos), {
                behavior: 'smooth',
                block: 'center'
            });
            if (isScrollSuccessful && nudgeTelepointer && telepointerEl !== null) {
                // We don't run this callback in SSR, so no need to escape it with an isSSR check
                // eslint-disable-next-line no-restricted-syntax
                observerRef.current = new IntersectionObserver(([entry])=>{
                    if (entry.isIntersecting) {
                        fullPageEditorPresetAPI?.core.actions.execute(nudgeTelepointer(activeSessionId));
                        killObserver();
                    }
                });
                observerRef.current.observe(telepointerEl);
                // Edge case: Set a timeout to disconnect the observer if intersection doesn't happen
                // 5000ms is an arbitrary time and can be reduced.
                timeoutRef.current = setTimeout(()=>{
                    killObserver();
                }, 5000);
            }
            if (!isScrollSuccessful) experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: new Error('Scroll is not successful'),
                attributes: {
                    isNudgeTelepointerDefined: nudgeTelepointer !== undefined,
                    hasValidTelepointerElement: telepointerEl !== null
                }
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE)
            });
            return isScrollSuccessful;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: error
            });
            return false;
        }
    }, [
        activeSessionId,
        activeTelepointerPos,
        activity,
        contentMode,
        contentType,
        fullPageEditorPresetAPI,
        experienceTracker,
        isEligibleToScroll,
        telepointerEl
    ]);
    return {
        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
        isEligibleToScroll: isEligibleToScroll,
        scrollToTelepointer: scrollToTelepointer
    };
};
module.exports["getTelepointerEl"] = $99b335d011a83318$export$d32c4eeaa4d40cd3;
module.exports["useScrollToTelepointer"] = $99b335d011a83318$export$3e8e4ca69eec4635;

});

parcelRegister("uBose", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $lpNn5 = parcelRequire("lpNn5");


var $3izAL = parcelRequire("3izAL");

var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $9wGTI = parcelRequire("9wGTI");


var $9VtwR = parcelRequire("9VtwR");


var $azPio = parcelRequire("azPio");

const $09acd215ab95c7d5$var$i18n = (0, $kSwu1.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    clickToFind: {
        id: "team-presence.menu.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu.click-to-find-not-available",
        defaultMessage: "Inactive"
    },
    clickToFollow: {
        id: "team-presence.menu.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $09acd215ab95c7d5$var$containerStyles = (0, $buxP3.xcss)({
    position: 'relative'
});
const $09acd215ab95c7d5$var$avatarBadgeStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    height: '12px',
    width: '12px',
    borderRadius: 'radius.small',
    color: 'color.text.inverse',
    // TODO: This will need to be swapped for the foregroundColor, based on sessionId
    boxShadow: 'elevation.shadow.overflow',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '10px',
    zIndex: 'card',
    userSelect: 'none'
});
const $09acd215ab95c7d5$var$tooltipTextStyles = (0, $buxP3.xcss)({
    textAlign: 'center'
});
const $09acd215ab95c7d5$var$neutralHumanStyles = {
    container: "_1mT5xdRAKS",
    tooltipText: "_2fwxA5DIqT"
};
const $09acd215ab95c7d5$var$EditorAvatarBadge = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { borderColor: backgroundColor, badgeTextColor: badgeTextColor, name: name } = t0;
    let t1;
    if ($[0] !== name) {
        t1 = name?.substring(0, 1);
        $[0] = name;
        $[1] = t1;
    } else t1 = $[1];
    const firstInitial = t1;
    const t2 = backgroundColor;
    const t3 = badgeTextColor;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = (0, $buxP3.xcss)({
            backgroundColor: t2,
            color: t3
        });
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = [
            $09acd215ab95c7d5$var$avatarBadgeStyles,
            t4
        ];
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== firstInitial) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "editor-avatar-badge-initial",
            as: "span"
        }, firstInitial);
        $[7] = firstInitial;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            testId: "editor-avatar-badge",
            alignItems: "center",
            justifyContent: "center",
            xcss: t5
        }, t6);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
};
const $09acd215ab95c7d5$var$TooltipText = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $09acd215ab95c7d5$var$tooltipTextStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $09acd215ab95c7d5$var$NeutralHumanTooltipText = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $09acd215ab95c7d5$var$neutralHumanStyles.tooltipText
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $09acd215ab95c7d5$export$9b9667d767e90372 = (t0)=>{
    const $ = (0, $bDgLe.c)(70);
    let avatarProps;
    let contentType;
    let isEligibleToScroll;
    let isScrollToFeatureEnabled;
    let participant;
    if ($[0] !== t0) {
        const { contentMode: _contentMode, contentId: _contentId, contentType: t1, isEligibleToScroll: t2, isScrollToFeatureEnabled: t3, participant: t4, ...t5 } = t0;
        contentType = t1;
        isEligibleToScroll = t2;
        isScrollToFeatureEnabled = t3;
        participant = t4;
        avatarProps = t5;
        $[0] = t0;
        $[1] = avatarProps;
        $[2] = contentType;
        $[3] = isEligibleToScroll;
        $[4] = isScrollToFeatureEnabled;
        $[5] = participant;
    } else {
        avatarProps = $[1];
        contentType = $[2];
        isEligibleToScroll = $[3];
        isScrollToFeatureEnabled = $[4];
        participant = $[5];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { activity: activity, color: participantColor, id: id, isCurrentUser: isCurrentUser, name: name } = participant;
    const displayedSrc = isCurrentUser ? `/wiki/aa-avatar/${id}` : participant.src;
    let t1;
    if ($[6] !== activity || $[7] !== formatMessage) {
        t1 = activity === "editor" ? formatMessage($09acd215ab95c7d5$var$i18n.editing) : formatMessage($09acd215ab95c7d5$var$i18n.viewing);
        $[6] = activity;
        $[7] = formatMessage;
        $[8] = t1;
    } else t1 = $[8];
    const activityText = t1;
    let t2;
    if ($[9] !== activityText || $[10] !== contentType || $[11] !== formatMessage || $[12] !== name || $[13] !== participant.agentOwnerName || $[14] !== participant.avatarKind) {
        const agentLabelKind = (0, $azPio.toAgentLabelKind)(participant.avatarKind);
        const shouldUseAgentLabel = (0, $9VtwR.isCanvasContentType)(contentType) && agentLabelKind !== undefined && (0, $9wGTI.fg)("canvas_agent_presence_facepile_frontend");
        t2 = shouldUseAgentLabel ? (0, $azPio.formatAgentPresenceLabel)({
            actorName: participant.agentOwnerName,
            kind: agentLabelKind,
            name: name
        }, formatMessage) : (0, $9VtwR.isCanvasContentType)(contentType) ? name : `${name} (${activityText})`;
        $[9] = activityText;
        $[10] = contentType;
        $[11] = formatMessage;
        $[12] = name;
        $[13] = participant.agentOwnerName;
        $[14] = participant.avatarKind;
        $[15] = t2;
    } else t2 = $[15];
    const label = t2;
    let t3;
    if ($[16] !== id || $[17] !== isCurrentUser) {
        t3 = isCurrentUser ? (0, $9VtwR.getCurrentUserColors)() : (0, $9VtwR.getParticipantColors)(id);
        $[16] = id;
        $[17] = isCurrentUser;
        $[18] = t3;
    } else t3 = $[18];
    const colors = t3;
    const borderColor = participantColor ?? colors.backgroundColor;
    let t4;
    if ($[19] !== contentType || $[20] !== isCurrentUser || $[21] !== participant.followCursor) {
        t4 = !isCurrentUser && (0, $9VtwR.isCanvasContentType)(contentType) && participant.followCursor;
        $[19] = contentType;
        $[20] = isCurrentUser;
        $[21] = participant.followCursor;
        $[22] = t4;
    } else t4 = $[22];
    const shouldShowClickToFollow = t4;
    const shouldShowClickToFind = Boolean(isScrollToFeatureEnabled) && participant.activity !== "viewer";
    const useNeutralHumanAvatar = (0, $9wGTI.fg)("confluence_neutral_human_presence_avatars") && (participant.avatarKind === undefined || participant.avatarKind === "user");
    if (useNeutralHumanAvatar) {
        let t5;
        if ($[23] !== label) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$NeutralHumanTooltipText, null, label);
            $[23] = label;
            $[24] = t5;
        } else t5 = $[24];
        let t6;
        if ($[25] !== shouldShowClickToFollow) {
            t6 = shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$NeutralHumanTooltipText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFollow));
            $[25] = shouldShowClickToFollow;
            $[26] = t6;
        } else t6 = $[26];
        let t7;
        if ($[27] !== isEligibleToScroll || $[28] !== shouldShowClickToFind) {
            t7 = shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                justifyContent: "center"
            }, isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable));
            $[27] = isEligibleToScroll;
            $[28] = shouldShowClickToFind;
            $[29] = t7;
        } else t7 = $[29];
        let t8;
        if ($[30] !== t5 || $[31] !== t6 || $[32] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6, t7);
            $[30] = t5;
            $[31] = t6;
            $[32] = t7;
            $[33] = t8;
        } else t8 = $[33];
        let t9;
        if ($[34] !== avatarProps || $[35] !== displayedSrc || $[36] !== label || $[37] !== name) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "column",
                alignItems: "center",
                gap: "space.0",
                xcss: $09acd215ab95c7d5$var$neutralHumanStyles.container
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                ...avatarProps,
                appearance: "circle",
                borderColor: "var(--ds-surface, #FFFFFF)",
                label: label,
                name: name,
                size: "small",
                src: displayedSrc
            }));
            $[34] = avatarProps;
            $[35] = displayedSrc;
            $[36] = label;
            $[37] = name;
            $[38] = t9;
        } else t9 = $[38];
        let t10;
        if ($[39] !== t8 || $[40] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: t8
            }, t9);
            $[39] = t8;
            $[40] = t9;
            $[41] = t10;
        } else t10 = $[41];
        return t10;
    }
    let t5;
    if ($[42] !== label) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$TooltipText, null, label);
        $[42] = label;
        $[43] = t5;
    } else t5 = $[43];
    let t6;
    if ($[44] !== shouldShowClickToFollow) {
        t6 = shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$TooltipText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFollow));
        $[44] = shouldShowClickToFollow;
        $[45] = t6;
    } else t6 = $[45];
    let t7;
    if ($[46] !== isEligibleToScroll || $[47] !== shouldShowClickToFind) {
        t7 = shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            justifyContent: "center"
        }, isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable));
        $[46] = isEligibleToScroll;
        $[47] = shouldShowClickToFind;
        $[48] = t7;
    } else t7 = $[48];
    let t8;
    if ($[49] !== t5 || $[50] !== t6 || $[51] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6, t7);
        $[49] = t5;
        $[50] = t6;
        $[51] = t7;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== avatarProps || $[54] !== borderColor || $[55] !== displayedSrc || $[56] !== label || $[57] !== name) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            ...avatarProps,
            appearance: "circle",
            borderColor: borderColor,
            label: label,
            name: name,
            size: "small",
            src: displayedSrc
        });
        $[53] = avatarProps;
        $[54] = borderColor;
        $[55] = displayedSrc;
        $[56] = label;
        $[57] = name;
        $[58] = t9;
    } else t9 = $[58];
    let t10;
    if ($[59] !== activity || $[60] !== borderColor || $[61] !== colors || $[62] !== name) {
        t10 = activity === "editor" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$EditorAvatarBadge, {
            borderColor: borderColor,
            badgeTextColor: colors.textColor,
            name: name
        });
        $[59] = activity;
        $[60] = borderColor;
        $[61] = colors;
        $[62] = name;
        $[63] = t10;
    } else t10 = $[63];
    let t11;
    if ($[64] !== t10 || $[65] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            direction: "column",
            alignItems: "center",
            gap: "space.0",
            xcss: $09acd215ab95c7d5$var$containerStyles
        }, t9, t10);
        $[64] = t10;
        $[65] = t9;
        $[66] = t11;
    } else t11 = $[66];
    let t12;
    if ($[67] !== t11 || $[68] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t8
        }, t11);
        $[67] = t11;
        $[68] = t8;
        $[69] = t12;
    } else t12 = $[69];
    return t12;
};
module.exports["PresenceAvatar"] = $09acd215ab95c7d5$export$9b9667d767e90372;

});

parcelRegister("8ISxc", function(module, exports) {

let $659cbc36a7ae465a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $659cbc36a7ae465a$var$load("1Kk1a").then(()=>parcelRequire('5ZJn7'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("3uWTb", function(module, exports) {

let $28c1da935aecc7b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28c1da935aecc7b2$var$load("6xy0M"),
    $28c1da935aecc7b2$var$load("7Y0AX"),
    $28c1da935aecc7b2$var$load("9lYw8")
]).then(()=>parcelRequire('23mW9'));

});


//# sourceMappingURL=PagePresence.504989ce.js.map
